import CreateSubscriptionContractRequestModelBase from '../_generated/modelBases/create-subscription-contract-request-model-base';

export default class CreateSubscriptionContractRequestModel extends CreateSubscriptionContractRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
